<template>
    <section style="min-height: 90vh;">
        <div class="container-fluid">
            <div class="col-md-5 mx-auto pt-5">
                <h1 class="mb-5 line-height-mobile" style="font-weight: 900; line-height: 44px; font-size: 32px;">{{ security.name }}</h1>
                <div class="row">
                    <div class="col-md-4 my-auto ml-auto">
                        <div class="optimize-share text-right">
                            <!-- Sharingbutton Facebook -->
                            <a :href="'https://facebook.com/sharer/sharer.php?u='+security.current_url" target="_blank" rel="noopener" aria-label="Share on Facebook" class="mr-2">
                                <svg id="svgshare" fill="currentColor" height="15" width="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/></svg>
                            </a>

                            <!-- Sharingbutton Twitter -->
                            <a :href="'https://twitter.com/intent/tweet/?text='+security.name+'&amp;url='+security.current_url" target="_blank" rel="noopener" aria-label="Share on Twitter" class="mr-2">
                                <svg id="svgshare" fill="currentColor" height="18" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"/></svg>
                            </a>

                            <!-- Sharingbutton E-Mail -->
                            <a :href="'mailto:?subject='+security.name+'&amp;body='+security.current_url" target="_self" rel="noopener" aria-label="Share by E-Mail">
                                <svg id="svgshare" fill="currentColor" height="18" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z"/></svg>
                            </a>
                        </div>
                    </div>
                </div>
<!--                 <div class="py-2">
                    <a class="mb-0 light-blue-01 fts-12" :href="'/notre-vue-des-marchés'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                        </svg>
                        Retour aux articles
                    </a>
                </div> -->
                <div class="text-center">
                    {{ security.name }}
                </div>
                <div class="text-center">
                    {{ security.isin }}
                </div>
                <div class="text-center">
                    {{ security.sector.name }}
                </div>
                <div class="text-center">
                    {{ security.asset_class.name }}
                </div>
                <div class="text-center">
                   Score myfo: {{ security.esg_score }}
                </div>
<!--                 <div class="py-2 mb-5">
                    <a class="mb-0 light-blue-01 fts-14" :href="'/notre-vue-des-marchés'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                        </svg>
                        Retour aux articles
                    </a>
                </div> -->
                <div id="app">
                    <AwesomeVueStarRating :star="security.esg_score" :starSize="starSize" :hasResults="true" :hasDescription="true" :ratingDescription="desc" v-model="newstar" @click="storestars"/>
                </div>
                <div v-if="has_like == 0" style="display: inline-block;">
                    <textarea id="commentblog" rows="4" cols="50" class="w-100" v-model="new_ranking"></textarea>
                    <button
                        type="submit"
                        style="background-color: transparent; border: none;"
                        @click="store">
                        <svg width="29" height="29" aria-label="clap" id="clap" fill="currentColor">
                            <g fill-rule="evenodd">
                                <path d="M13.74 1l.76 2.97.76-2.97zM16.82 4.78l1.84-2.56-1.43-.47zM10.38 2.22l1.84 2.56-.41-3.03zM22.38 22.62a5.11 5.11 0 0 1-3.16 1.61l.49-.45c2.88-2.89 3.45-5.98 1.69-9.21l-1.1-1.94-.96-2.02c-.31-.67-.23-1.18.25-1.55a.84.84 0 0 1 .66-.16c.34.05.66.28.88.6l2.85 5.02c1.18 1.97 1.38 5.12-1.6 8.1M9.1 22.1l-5.02-5.02a1 1 0 0 1 .7-1.7 1 1 0 0 1 .72.3l2.6 2.6a.44.44 0 0 0 .63-.62L6.1 15.04l-1.75-1.75a1 1 0 1 1 1.41-1.41l4.15 4.15a.44.44 0 0 0 .63 0 .44.44 0 0 0 0-.62L6.4 11.26l-1.18-1.18a1 1 0 0 1 0-1.4 1.02 1.02 0 0 1 1.41 0l1.18 1.16L11.96 14a.44.44 0 0 0 .62 0 .44.44 0 0 0 0-.63L8.43 9.22a.99.99 0 0 1-.3-.7.99.99 0 0 1 .3-.7 1 1 0 0 1 1.41 0l7 6.98a.44.44 0 0 0 .7-.5l-1.35-2.85c-.31-.68-.23-1.19.25-1.56a.85.85 0 0 1 .66-.16c.34.06.66.28.88.6L20.63 15c1.57 2.88 1.07 5.54-1.55 8.16a5.62 5.62 0 0 1-5.06 1.65 9.35 9.35 0 0 1-4.93-2.72zM13 6.98l2.56 2.56c-.5.6-.56 1.41-.15 2.28l.26.56-4.25-4.25a.98.98 0 0 1-.12-.45 1 1 0 0 1 .29-.7 1.02 1.02 0 0 1 1.41 0zm8.89 2.06c-.38-.56-.9-.92-1.49-1.01a1.74 1.74 0 0 0-1.34.33c-.38.29-.61.65-.71 1.06a2.1 2.1 0 0 0-1.1-.56 1.78 1.78 0 0 0-.99.13l-2.64-2.64a1.88 1.88 0 0 0-2.65 0 1.86 1.86 0 0 0-.48.85 1.89 1.89 0 0 0-2.67-.01 1.87 1.87 0 0 0-.5.9c-.76-.75-2-.75-2.7-.04a1.88 1.88 0 0 0 0 2.66c-.3.12-.61.29-.87.55a1.88 1.88 0 0 0 0 2.66l.62.62a1.88 1.88 0 0 0-.9 3.16l5.01 5.02c1.6 1.6 3.52 2.64 5.4 2.96a7.16 7.16 0 0 0 1.18.1c1.03 0 2-.25 2.9-.7A5.9 5.9 0 0 0 23 23.24c3.34-3.34 3.08-6.93 1.74-9.17l-2.87-5.04z"></path>
                            </g>
                        </svg>
                    </button>
                </div>
                <div v-else>
                    <p>Merci d'avoir noté ce titre!</p>
                </div>
                <div style="display: inline-block;" class="mr-3">
                    {{ ranks }}
                </div>
                <svg width="25" height="25" aria-label="responses" style="display: inline-block;" class="mr-3" fill="currentColor" id="commentsvg">
                    <path d="M19.07 21.12a6.33 6.33 0 0 1-3.53-1.1 7.8 7.8 0 0 1-.7-.52c-.77.21-1.57.32-2.38.32-4.67 0-8.46-3.5-8.46-7.8C4 7.7 7.79 4.2 12.46 4.2c4.66 0 8.46 3.5 8.46 7.8 0 2.06-.85 3.99-2.4 5.45a6.28 6.28 0 0 0 1.14 2.59c.15.21.17.48.06.7a.69.69 0 0 1-.62.38h-.03zm0-1v.5l.03-.5h-.03zm-3.92-1.64l.21.2a6.09 6.09 0 0 0 3.24 1.54 7.14 7.14 0 0 1-.83-1.84 5.15 5.15 0 0 1-.16-.75 2.4 2.4 0 0 1-.02-.29v-.23l.18-.15a6.6 6.6 0 0 0 2.3-4.96c0-3.82-3.4-6.93-7.6-6.93-4.19 0-7.6 3.11-7.6 6.93 0 3.83 3.41 6.94 7.6 6.94.83 0 1.64-.12 2.41-.35l.28-.08z" fill-rule="evenodd"></path>
                </svg>
                <div style="display: inline-block;">
                        {{ security.num_comment }}
                    </div>
                <div class="py-2 mb-3" style="border-bottom: 1px solid rgb(230, 230, 230);"></div>
                <div class="py-2">
                    <p class="mb-0 font-weight-bold">Commentaires</p>
                </div>
                <div style="max-height: 800px; overflow-y: scroll; overflow-x: hidden;">
                    <div v-for="comment in coms" :key="comment.id" class="mb-2 mr-2">
                        <div class="py-2">
                            <span class="fts-14" style="font-weight: 900;">{{ comment.user.firstname }}</span> <span class="fts-12" style="color: rgb(120, 120, 120);">le {{ comment.created_at }}</span>
                        </div>
                        <div class="p-3 w-100" style="background-color: rgb(242, 242, 242); border-radius: 5px; max-width: 100%;">
                            <div style="max-width: 100%;">{{ comment.comment }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="user == null" class="mb-5">
                    <a href="/login" class="light-blue-01">Connectez-vous</a> ou <a href="/register" class="light-blue-01">créer un compte</a> pour commenter
                </div>
                <div v-else class="my-5">
                    <div class="py-2">
                        <p class="mb-0 font-weight-bold">Laisser un commentaire</p>
                    </div>
                    <textarea id="commentblog" rows="4" cols="50" class="w-100" v-model="newcomment"></textarea>
                    <button
                        type="submit"
                        class="btn-home-main"
                        @click="storecomment">Commenter</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import AwesomeVueStarRating from 'awesome-vue-star-rating'

    export default {
        props: [
            'security',
            'comments',
            'user',
            'token',
            'route',
        ],

        data() {
            return {
                coms:[],
                new_ranking: 0,
                newcomment: '',
                newstar: 0,
                ranking: '',
                ranks:0,
                has_like: 0,
                id: 1,
                updatecomment: '',
                sec: '',
                desc: [
                    {
                    text: 'Poor',
                    class: 'star-poor'
                    },
                    {
                    text: 'Below Average',
                    class: 'star-belowAverage'
                    },
                    {
                    text: 'Average',
                    class: 'star-average'
                    },
                    {
                    text: 'Good',
                    class: 'star-good'
                    },
                    {
                    text: 'Excellent',
                    class: 'star-excellent'
                    }
                ],
                starSize: 'lg' //xs/6x
            }
        },
        name: 'app',
        components: {
            AwesomeVueStarRating
        },

        mounted() {
           this.index();
           this.indexcomment();

           this.sec =  this.security;

           this.ranks = this.security.esg_score_users;

           this.coms = this.comments;

        },

        methods: {
           async index() {
                const { data } = await window.axios.get('/security/ranking/show/'+this.security.id);
                console.log(data);
                this.ranking = data;
                this.likes = this.ranking;
            },
            async store() {
                await window.axios.post('/security/ranking/store/like', {message:this.new_ranking,'security_id':this.security.id});
                this.ranking = this.new_ranking;
                this.has_like = 1;
                this.ranks = this.ranks*(this.sec.total_esg_votes /(this.sec.total_esg_votes+1)) + this.ranking/(this.sec.total_esg_votes+1);
                console.log(this.ranking);
                //this.index();
            },
            async indexcomment() {
                const { data } = await window.axios.get('/security/ranking/show/comment/'+this.security.id);
                console.log(data);
                this.commens = data;
                this.coms = this.commens;
            },
            async storecomment() {
                await window.axios.post('/security/ranking/store/comment', {message:this.newcomment,'security_id':this.security.id});
                console.log(this.newcomment);
                this.newcomment = '';
                this.indexcomment();
            },
            async storestars() {
                await window.axios.post('/security/ranking/store/comment', {message:this.newstar,'security_id':this.security.id});
                console.log('newstar');
                console.log('newstar'+this.newstar);
                this.newstar = '';
                //this.indexcomment();
            },
        }
    }
</script>
